import { Box } from '@mui/material';

import { Hero } from './components/Hero';
import { About } from './components/About';
import { PainPoints } from './components/PainPoints';
import { Approach } from './components/Approach';
import { Credentials } from './components/Credentials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

export function App() {
  return (
    <Box component="main" sx={{ overflow: 'hidden' }}>
      <Hero />
      <PainPoints />
      <About />
      <Approach />
      <Credentials />
      <Contact />
      <Footer />
    </Box>
  );
}

export default App;
